import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router';
import type { MultiLang } from '../../config';

interface Props {
    lang: MultiLang;
    baseUrl: string;
    total: number;
    start: number;
}

const XwordsEntriesPageNavi = (props: Props) => {
    const { baseUrl, total, start } = props;
    if (total <= 20 || start > total) {
        return null;
    }
    const now = Math.ceil((start + 1) / 20);
    const min = 1;
    const max = Math.ceil(total / 20);
    const prev = now === 1 ? 0 : now - 1;
    const next = now === max ? 0 : now + 1;
    let rangeMin = now - 3;
    if (rangeMin < 2) {
        rangeMin = 2;
    }
    let rangeMax = now + 3;
    if (rangeMax > max - 1) {
        rangeMax = max - 1;
    }
    const link = (num: number, el?: ReactNode) => {
        const label = el || num;
        const url = baseUrl + (num - 1 > 0 ? `&start=${(num - 1) * 20}` : '');
        return num === now ? <>({label})</> : <Link to={url}>{label}</Link>;
    };
    const items: { key: string; node: ReactNode }[] = [];
    if (prev !== 0) {
        items.push({ key: 'prev', node: link(prev, <>&laquo;</>) });
    }
    items.push({ key: `${min}`, node: link(min) });
    if (now - min > 4) {
        items.push({ key: 'gap-prev', node: <>...</> });
    }
    for (let range = rangeMin; range <= rangeMax; range++) {
        items.push({ key: `${range}`, node: link(range) });
    }
    if (max - now > 4) {
        items.push({ key: 'gap-next', node: <>...</> });
    }
    items.push({ key: `${max}`, node: link(max) });
    if (next !== 0) {
        items.push({ key: 'next', node: link(next, <>&raquo;</>) });
    }
    return (
        <nav className="pagenavi">
            {items.map((item, index) => (
                <Fragment key={item.key}>
                    {index !== 0 && <>&nbsp;</>}
                    {item.node}
                </Fragment>
            ))}
        </nav>
    );
};

export default XwordsEntriesPageNavi;
